import { SectionView } from '../../ui_canvas_engine/SectionView.ts';
import { PIXI } from '@colonist/pixi';
export class UIInvisibleBackgroundView extends SectionView {
    setClickAction(action) {
        if (!this.interactive) this.interactive = true;
        this.on('click', ()=>{
            action();
        });
        this.on('tap', ()=>{
            action();
        });
    }
    drawBg() {
        this.bg = new PIXI.Graphics();
        this.bg.beginFill(0, 0.01);
        this.bg.drawRoundedRect(0, 0, this.width, this.height, 5);
        this.bg.endFill();
        this.addChild(this.bg);
    }
    constructor(x, y, w, h, layer, container, action){
        super(x, y, w, h, container);
        this.setClickAction(action);
        this.zIndex = layer;
        container.sortChildren();
    }
}
